import React, { Component } from 'react'
import "./skillinfo.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import 'antd/dist/antd.css';
import { UrlSearch } from '../../axios/localstorage';
import { getApiResultInfo , getApiSetDemand , getApiSend } from '../../axios/api';


export default class skillinfo extends Component {


    state = {
        data:{},
        currentIndex:0,
        type:0,

        newsType:1,

        page:1,
        total:11,

        id:"",
        key:"",
        name:"",
        mobile:"",
        code:"",
        msg:"",
        showMsg:false,
        isSend:false,
        countDownNum:60,

        alert:false,
        showSuccess:false,
        list:[],
        arr:[],
        
    }

    componentWillMount(){

        window.scroll(0,0);


    }

    componentDidMount(){
        let id = UrlSearch('id');
        this.setState({id})
        this.getInfo(id);
    }   

    getInfo=(id)=>{
        let param = {
            id
        }

        getApiResultInfo(param)
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    data:data.info,
                    list:data.list,
                    arr:data.lists
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    gotoSend=()=>{

        if(!this.state.mobile){
            this.setState({
                msg:'请先输入手机号码！',
                showMsg:true
            })
            return false;
        }
    
    
        var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    
        if (!myreg.test(this.state.mobile)) {
    
            this.setState({
                msg:'手机号码格式不正确',
                showMsg:true
            })
            return false;
        }
    
        let event = "setdemand";
    
        let param = {
            event:event,
            mobile:this.state.mobile
        }
    
    
        getApiSend(param)
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    isSend:true
                })
        
                this.countDown();
            }else{
                this.setState({
                    msg:req.data.msg
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    
        
    }

    countDown=() =>{ 
        let countDownNum = this.state.countDownNum-1;//获取倒计时初始值
        //如果将定时器设置在外面，那么用户就看不到countDownNum的数值动态变化，所以要把定时器存进data里面
        this.timer = setInterval(() => {

            if(countDownNum<=0){
                clearInterval(this.timer);
                this.setState({ countDownNum:60,  isSend: false })
            }else{
                this.setState({
                    countDownNum:(countDownNum--)
                })
            }
        }, 1000);
    }



    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    changeInfo=(id)=>{
        this.gotoPage('/skillinfo?id='+id );
        this.getInfo(id);
        window.scroll(0,0);
    }

    gotochangeType=(type)=>{
        let name = "type"+type;
        let div = document.getElementById(name);
        let  h = div.offsetTop - 180;
        // console.log(h);
        window.scroll(0,h);
        this.setState({
            type
        })
    }

    gotoPush=()=>{

        if(!this.state.key){
            this.setState({
                msg:'请先输入您的需求！',
                showMsg:true
            })
            return false;
        }

        if(!this.state.name){
            this.setState({
                msg:'请先输入联系人！',
                showMsg:true
            })
            return false;
        }

        if(!this.state.mobile){
            this.setState({
                msg:'请先输入手机号码！',
                showMsg:true
            })
            return false;
        }
    
        var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    
        if (!myreg.test(this.state.mobile)) {
    
            this.setState({
                msg:'手机号码格式不正确',
                showMsg:true
            })
            return false;
        }

        if(!this.state.code){
            this.setState({
                msg:'请先输入验证码！',
                showMsg:true
            })
            return false;
        }

        let param = {
            content:this.state.key,
            name:this.state.name,
            mobile:this.state.mobile,
            code:this.state.code,
            type:1,
            er_id:this.state.id
        }

        getApiSetDemand(param)
        .then( req =>{
            if(req.data.code === 1){

                this.setState({
                    showSuccess:true,
                    key:""
                })

            }else{
                this.setState({
                    msg:req.data.msg,
                    showMsg:true
                })
            }
        }).catch( err =>{
            console.error(err);
        })

        
    }

    render() {
        return (
            <div className='skillinfo'>
                <Header type={6} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/skill')}}>技术成果</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>技术成果详情</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='hinfo'>
                    <div className='cen'>
                        <div className='main'>
                            {/* <div className='bg' style={{backgroundImage:"url('/www/assets/imgs/chanye.png')"}}>
                                <div className='new' style={{backgroundImage:"url('/www/assets/imgs/zuixin.png')"}}>最新</div>
                            </div> */}
                            <div className='mtext'>
                                <h2>{this.state.data.title}</h2>
                                {/* <p>{this.state.data.innovation}</p> */}
                                <div className='cbox'>
                                    <div>{this.state.data.industry_text}</div>
                                </div>
                                <div className='mflex'>
                                    <div className='mfi'>
                                        <h3>项目负责人：</h3>
                                        <p>{this.state.data.head}</p>
                                    </div>
                                    <div className='mfi'>
                                        <h3>工作单位：</h3>
                                        <p>{this.state.data.company}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>

                            <div className='box'>
                                <div className='left'>
                                    <div className='ptype'>
                                        <div className='pflex'>
                                            <div onClick={()=>{this.gotochangeType(0)}} className={this.state.type === 0?'pfi pf_active':"pfi"} style={this.state.type === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>项目简介</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                            <div hidden={!this.state.data.innovation} onClick={()=>{this.gotochangeType(1)}}  className={this.state.type === 1?'pfi pf_active':"pfi"} style={this.state.type === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>技术/产品创新性</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                            <div hidden={!this.state.data.riprs} onClick={()=>{this.gotochangeType(2)}}  className={this.state.type === 2?'pfi pf_active':"pfi"} style={this.state.type === 2?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>知识产权情况</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                            <div hidden={!this.state.data.marks} onClick={()=>{this.gotochangeType(3)}}  className={this.state.type === 3?'pfi pf_active':"pfi"} style={this.state.type === 3?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>市场情况</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                            <div hidden={!this.state.data.team} onClick={()=>{this.gotochangeType(4)}}  className={this.state.type === 4?'pfi pf_active':"pfi"} style={this.state.type === 4?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                                <p>项目团队情况</p>
                                                <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='name' id="type0">
                                    <img alt="" src="/www/assets/imgs/lei.png" />
                                        <h2>项目简介</h2>
                                    </div>

                                    <div className="cont" dangerouslySetInnerHTML={{
                                        __html: this.state.data.info
                                    }}></div>

                                    <div hidden={!this.state.data.innovation}>
                                        <div className='name' id="type1">
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>技术/产品创新性</h2>
                                        </div>

                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.data.innovation
                                        }}></div>
                                    </div>

                                    <div hidden={!this.state.data.riprs}>
                                        <div className='name' id="type2">
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>知识产权情况</h2>
                                        </div>

                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.data.riprs
                                        }}></div>
                                    </div>

                                    <div hidden={!this.state.data.marks}>
                                        <div className='name' id="type3">
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>市场情况</h2>
                                        </div>

                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.data.marks
                                        }}></div>
                                    </div>

                                    <div hidden={!this.state.data.team}>
                                        <div className='name' id="type4">
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>项目团队情况</h2>
                                        </div>

                                        <div className="cont" dangerouslySetInnerHTML={{
                                            __html: this.state.data.team
                                        }}></div>
                                    </div>


                                </div>
                                <div className='right'>
                                    <div className='rpush'>
                                        <div className='rname'>
                                            <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2><span>免费</span>发布科技需求 千万专家<span>极速</span>解决</h2>
                                        </div>
                                        <div className='rbox'>
                                            <textarea placeholder='请输入您的需求…' value={this.state.key} onChange={(ev)=>{this.setState({key:ev.target.value})}}></textarea>
                                            <button onClick={()=>{this.setState({alert:true})}}>提交需求</button>
                                        </div>
                                    </div>

                                    <div className='rabout'>
                                        <div className='rname'>
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>相关成果</h2>
                                        </div>
                                        {
                                            this.state.arr.map((item,index)=>{
                                                return <div className='rcard' onClick={()=>{this.changeInfo(item.id)}} key={index}>
                                                            <h2>{item.title}</h2>
                                                            <p>{item.innovation}</p>
                                                            <div className='cbox'>
                                                                <h4>项目负责人：<span>{item.head}</span></h4>
                                                                {/* <h4>工作单位：<span>{item.company}</span></h4> */}
                                                            </div>
                                                        </div>
                                            })
                                        }
                                    </div>

                                    <div className='rdiv'>
                                        <div className='rname'>
                                        <img alt="" src="/www/assets/imgs/lei.png" />
                                            <h2>相关专家</h2>
                                        </div>
                                        {
                                            this.state.list.map((item,index)=>{
                                                return <div className='card' key={index} onClick={()=>{this.gotoPage('/talentsinfo?id='+item.id);}}>
                                                            <div className='cimg' style={{backgroundImage:"url('"+item.avatar+"')"}}></div>
                                                            <div className='ctext'>
                                                                <h2>{item.name} <span>{item.service}/{item.posname}</span></h2>
                                                                <div className='cbox'>
                                                                    {
                                                                        item.redirection.map((elem,num)=>{
                                                                            return <div key={num}>{elem}</div>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='alert' hidden={!this.state.alert}>
                    <div className='abox' hidden={this.state.showSuccess}>
                        <div className='atitle'>
                            <p>提交需求</p>
                            <img className='aclose' onClick={()=>{this.setState({alert:false})}} alt="" src="/www/assets/imgs/chacha.png" />
                        </div>
                        <div className='cen'>
                            <div className='adiv'>
                                <h1>需求内容</h1>
                                <textarea placeholder='请输入您的需求…' value={this.state.key} onChange={(ev)=>{this.setState({key:ev.target.value})}}></textarea>
                                <h1><span>*</span>联系人</h1>
                                <input placeholder='请输入联系人姓名' value={this.state.name} onChange={(ev)=>{this.setState({name:ev.target.value})}} />
                                <h1><span>*</span> 联系电话</h1>
                                <input placeholder='请输入联系电话' value={this.state.mobile} onChange={(ev)=>{this.setState({mobile:ev.target.value})}} />
                                <h1><span>*</span>验证码</h1>
                                <div className='aipt'>
                                    <div>
                                        <input placeholder='请输入验证码' value={this.state.code} onChange={(ev)=>{this.setState({code:ev.target.value})}} />
                                    </div>
                                    <button onClick={()=>{this.gotoSend()}} className={this.state.isSend?'send':''}>{this.state.isSend?this.state.countDownNum + "s 后重发":"发送验证码"}</button>
                                </div>
                                <div className='amsg'>
                                    <p hidden={!this.state.showMsg}>{this.state.msg}</p>
                                </div>
                                <button className='abtn' onClick={()=>{this.gotoPush()}}>提交</button>
                            </div>
                        </div>
                    </div>
                    <div className='ascu' hidden={!this.state.showSuccess}>
                        <div className='cen'>
                            <img alt="" src="/www/assets/imgs/wancheng.png" />
                        </div>
                        <p>提交成功</p>
                        <p>我们会第一时间查看您的需求</p>
                        <p>请您保持电话畅通，我们会及时和您联系</p>
                        <button onClick={()=>{this.setState({showSuccess:false,alert:false})}}>好的，我了解了</button>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
